export { fetchExternalLinks } from './external-links';
